import { AbstractControl, FormControl } from "@angular/forms";

export interface WorkspaceAbsenceCategory {
	id: string;
	enabled?: boolean;
	title: string;
	description?: string;
	durationType?: "basedOnTargetHours" | "customValue";
	duration?: string | null;
	isStatic?: boolean;
	visibleForUsers?: string[];
	visibleForGroups?: string[];
}
export interface WorkspaceAbsenceCategories extends Array<WorkspaceAbsenceCategory> {}
export interface WorkspaceAbsenceCategoryFormControl extends AbstractControl<WorkspaceAbsenceCategories> {}

export function createAbsencesControl() {
	return new FormControl<WorkspaceAbsenceCategories>([]);
}

export const defaultIds = [
	"00000000-0000-0000-0000-000000000000",
	"00000000-0000-0000-0000-111111111111",
	"00000000-0000-0000-0000-222222222222",
	"00000000-0000-0000-0000-333333333333",
	"00000000-0000-0000-0000-444444444444",
	"00000000-0000-0000-0000-555555555555",
	"00000000-0000-0000-0000-666666666666",
	"00000000-0000-0000-0000-777777777777",
];
export const defaultAbsenceIcons = new Map<string, string>([
	["00000000-0000-0000-0000-000000000000", "beach_access"],
	["00000000-0000-0000-0000-111111111111", "medical_services"],
	["00000000-0000-0000-0000-222222222222", "celebration"],
	["00000000-0000-0000-0000-333333333333", "school"],
	["00000000-0000-0000-0000-444444444444", "star"],
	["00000000-0000-0000-0000-555555555555", "money_off"],
	["00000000-0000-0000-0000-666666666666", "schedule"],
	["00000000-0000-0000-0000-777777777777", "event"],
]);
